import { prepareContentWithBase64Images } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatCommonInquiryBoardAnswerDetail,
	formatCommonInquiryBoardAnswerList,
} from './common-inquiry-board-answer.helper';
import { CommonInquiryBoardAnswerActions } from './common-inquiry-board-answer.redux';
import {
	IPayloadDeleteAnswerCommonInquiryBoardAnswerRequest,
	IPayloadDeleteCommonInquiryBoardAnswerRequest,
	IPayloadGetCommonInquiryBoardAnswerDetailRequest,
	IPayloadGetCommonInquiryBoardAnswerListRequest,
	IPayloadSaveAnswerCommonInquiryBoardAnswerRequest,
} from './common-inquiry-board-answer.type';

export function* getCommonInquiryBoardAnswerList(
	action: PayloadAction<IPayloadGetCommonInquiryBoardAnswerListRequest>
) {
	const { searchTypes, callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetCommonInquiryBoardListResponse> =
			yield API.getCommonInquiryBoardAnswerList({ searchTypes, ...rest });
		const content = formatCommonInquiryBoardAnswerList(res?.data?.content);

		yield put(
			CommonInquiryBoardAnswerActions.getCommonInquiryBoardAnswerListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			CommonInquiryBoardAnswerActions.getCommonInquiryBoardAnswerListFailure()
		);
	}
}

export function* getCommonInquiryBoardAnswerDetail(
	action: PayloadAction<IPayloadGetCommonInquiryBoardAnswerDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.ICommonInquiryBoard> =
			yield API.getCommonInquiryBoardAnswerDetail(id);
		const detail = formatCommonInquiryBoardAnswerDetail(res.data);

		const contents: string = yield prepareContentWithBase64Images(
			detail.contents
		);

		yield put(
			CommonInquiryBoardAnswerActions.getCommonInquiryBoardAnswerDetailSuccess({
				detail: {
					...detail,
					contents,
				},
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			CommonInquiryBoardAnswerActions.getCommonInquiryBoardAnswerDetailFailure()
		);
	}
}

export function* getCommonInquiryBoardAnswerDetailAnswer(
	action: PayloadAction<IPayloadGetCommonInquiryBoardAnswerDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.ICommonInquiryBoard> =
			yield API.getCommonInquiryBoardAnswerDetailAnswer(id);
		const detail = formatCommonInquiryBoardAnswerDetail(res.data);

		yield put(
			CommonInquiryBoardAnswerActions.getCommonInquiryBoardAnswerDetailAnswerSuccess(
				{
					detail,
				}
			)
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			CommonInquiryBoardAnswerActions.getCommonInquiryBoardAnswerDetailAnswerFailure()
		);
	}
}

export function* deleteCommonInquiryBoardAnswer(
	action: PayloadAction<IPayloadDeleteCommonInquiryBoardAnswerRequest>
) {
	const { ids, callback } = action.payload;

	try {
		yield API.deleteCommonInquiryBoardAnswer(ids);

		yield put(
			CommonInquiryBoardAnswerActions.deleteCommonInquiryBoardAnswerSuccess()
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			CommonInquiryBoardAnswerActions.deleteCommonInquiryBoardAnswerFailure()
		);
	}
}

export function* saveAnswerCommonInquiryBoard(
	action: PayloadAction<IPayloadSaveAnswerCommonInquiryBoardAnswerRequest>
) {
	const { callback, ...rest } = action.payload;
	try {
		yield API.saveAnswerCommonInquiryBoard(rest);

		yield put(
			CommonInquiryBoardAnswerActions.saveAnswerCommonInquiryBoardAnswerSuccess()
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			CommonInquiryBoardAnswerActions.saveAnswerCommonInquiryBoardAnswerFailure()
		);
	}
}

export function* deleteAnswerCommonInquiryBoard(
	action: PayloadAction<IPayloadDeleteAnswerCommonInquiryBoardAnswerRequest>
) {
	const { id, callback } = action.payload;
	try {
		yield API.deleteAnswerCommonInquiryBoard(id);

		yield put(
			CommonInquiryBoardAnswerActions.deleteAnswerCommonInquiryBoardAnswerSuccess()
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			CommonInquiryBoardAnswerActions.deleteAnswerCommonInquiryBoardAnswerFailure()
		);
	}
}
